import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';

import {
  GetTagsByIdsForQueryGQL, GetTagsByIdsForQueryQuery, SearchActivityEvents
} from 'generated/graphql';

import { MassRemoveTagsOperationData } from 'app/quick-apply/types/mass-operation-types';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';

import { MassOperationActivityEventPayload } from '../types';
import { map } from 'rxjs/operators';


@Component({
  selector: 'app-mass-remove-tags-event',
  templateUrl: './mass-remove-tags-event.component.html'
})
export class ASMassRemoveTagsEventComponent extends
  WithDisposableSubject() implements OnInit {

  @Input() item: SearchActivityEvents.Node;

  get payload(): MassOperationActivityEventPayload<MassRemoveTagsOperationData> {
    return this.item?.payload;
  }

  removedTags: GetTagsByIdsForQueryQuery['getTagsByIds'];

  /**
   *
   */
  constructor(
    private _getTagsService: GetTagsByIdsForQueryGQL,
    private _cd: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    const tagIds = this.payload.operationData.tagIds;
    this._getTags(tagIds).subscribe(
      (t) => {
        this.removedTags = t;
        this._cd.markForCheck();
      }
    );
  }

  private _getTags(tagIds: string[]) {
    return this._getTagsService.fetch({
      tagIds
    }).pipe(
      map(({data}) => data.getTagsByIds)
    );
  }
}
